import clsx from 'clsx';
import { SkeletonBlock } from './SkeletonBlock.tsx';

interface SkeletonButtonProps {
  icon?: boolean;
  rounded?: boolean;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

export function SkeletonButton({
  icon = false,
  rounded = false,
  size = 'md'
}: SkeletonButtonProps) {
  return (
    <SkeletonBlock
      className={clsx(
        'block',
        rounded && 'rounded-full',
        size === 'xs' && clsx('h-7', icon ? 'aspect-square' : 'w-20'),
        size === 'sm' && clsx('h-8', icon ? 'aspect-square' : 'w-22'),
        size === 'md' && clsx('h-9', icon ? 'aspect-square' : 'w-24'),
        size === 'lg' && clsx('h-10', icon ? 'aspect-square' : 'w-28'),
        size === 'xl' && clsx('h-11', icon ? 'aspect-square' : 'w-28')
      )}
    />
  );
}
